import { SxGeneral } from "../../../../../../../utils/types/generals"

type SxStyles = SxGeneral<'mapLink'>
export const useStyles = (): SxStyles => {
    return {
        
        mapLink: {
            cursor: 'pointer',
            color: 'primary.main',
            textDecoration: 'underline',
            '&:hover': {
                color: 'primary.dark',
            },
        },
    }
}